import { api } from "./client";

interface ImageUploadResponse {
  url: string;
}

interface UploadImageOptions {
  serviceId: string;
}

export const uploadImage = async (
  file: File,
  options: UploadImageOptions
): Promise<ImageUploadResponse> => {
  const formData = new FormData();
  formData.append("image", file);

  const response = await api.post<ImageUploadResponse>(
    "/v1/images",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      serviceId: options.serviceId,
    }
  );

  return response.data;
};
